<div class="container text-center p-5">
    <h3>
        You have been Successfully unsubscribed ! <br> To use the content subscribe the service by clicking on below button. 
    </h3>
    <button type="button" (click)="redirectToLp()" >SUBMIT</button>
</div>
